class Constants {

  static baseUrl() {
    return 'https://ebilling.pajakku.com/api'
  }

}

export default Constants
